import React from 'react'

const SecondaryBanner = (props) => {
  return (
    <section className='home-section secondary-banner'>
      <div className='container-fluid bg-color-ui-4'>
        <div className='container'>
          <div className='row py-3'>
            <div className='col-12'>
              <div className='bx-banner'>
                <h2 className='banner-title' title='E aí, animou? A gente tá aqui esperando por você!' tabIndex='0'>
                  e aí, animou? <br />
                  a gente tá aqui <br />
                  <strong>esperando por você :)</strong>
                </h2>
                <a href={process.env.REACT_APP_MEU_BAIRRO_ENDPOINT_SIGNUP} title='quero participar' className='btn btn-default btn-register' tabIndex='0'>quero vender</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SecondaryBanner



// WEBPACK FOOTER //
// ./src/HomePageItauMeuBairro/components/SecondaryBanner.js